/**
 * Removes day-related tokens from a format string.
 */
export function removeDayFromFormat(format: string) {
  return format.replace(/(do|Do|co|io|E|d|D|e|c|i)+/g, '');
}
